import React, {Component} from 'react';
import { BrowserRouter as Router,Route, Link } from 'react-router-dom';

export default class Header extends Component {
    render(){
        return (
        	<header className="rbl-header flex-full">
				<div className="container flex-full">
                    <div className="header-inner flex-full">
                    <Router>
                        <Link className="logo" target={"_blank"} to={{ pathname: "https://www.republicbankdominica.com" }} >
                            <img src={require('../../images/logo.png')} alt="RBL bank"/>
                        </Link>
                    </Router>
                    </div>
                </div>
            </header>
        )
    }
}